export type SearchVersionPreference = 'auto' | 'v1' | 'v2';

export type SearchVersionUsed = 'v1' | 'v2';

export const SEARCH_VERSION_PREFERENCE_STORAGE_KEY = 'searchVersionPreference';

export const SEARCH_VERSION_PREFERENCE_HEADER = 'X-Search-Version-Preference';

export const SEARCH_VERSION_RESPONSE_HEADER = 'X-Search-Version';

export const SEARCH_VERSION_PREFERENCE_OPTIONS: SearchVersionPreference[] = [
    'auto',
    'v1',
    'v2',
];
